import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { BrandInfoItem } from 'types/schema';
import { generateUrlBrandDetail } from 'utils/generateBrandDetailUrl';
import media from 'utils/mediaStyle';
import utilMessages from 'utils/messages';
import { getLocalOriginName } from '../../../utils/getLocalOriginName';
import kamereoLogo from '../_icons/kamereoLogo.svg';
import SVGIcon from 'components/SVGIcon/SVGIcon';
import { EventName, sendGA4Event } from 'utils/triggerGA4Event';
import capitalize from 'lodash/capitalize';

const ProductOriginInfo = styled.div`
  position: relative;
  padding: 12px;
  border-radius: 8px;
  background: #f5f5f4;
  margin: 8px 0px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;

  ${media.lg`
      margin: 20px 0px;
    `}
  ${({ isKamereoProduct }) =>
    isKamereoProduct &&
    `
    background: #F0F9F1;
  `}
`;

const ProductOriginItem = styled.div`
  display: flex;
  flex-direction: column;
`;
const ProductOriginLabel = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: #596056;
`;
const ProductOriginValue = styled.span`
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  color: #2f382c;
`;

const BrandValue = styled.span`
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  color: #136fd8;
`;

const KamereoLogoContainer = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
`;
interface ProductDetailsOriginInfoProps {
  product_id?: string;
  productOrigin?: string;
  vat?: number;
  brand?: BrandInfoItem;
  preservationLocal?: string;
  isKamereoProduct?: boolean;
}
const ProductDetailsOriginInfo = (props: ProductDetailsOriginInfoProps) => {
  const { productOrigin, vat, brand, preservationLocal, isKamereoProduct, product_id } = props;

  return (
    <ProductOriginInfo isKamereoProduct={isKamereoProduct}>
      <ProductOriginItem>
        <ProductOriginLabel>
          <FormattedMessage {...utilMessages.origin} />
        </ProductOriginLabel>
        <ProductOriginValue>{productOrigin ? getLocalOriginName(productOrigin) : 'N/A'}</ProductOriginValue>
      </ProductOriginItem>
      <ProductOriginItem>
        <ProductOriginLabel>
          <FormattedMessage {...utilMessages.vat} />
        </ProductOriginLabel>
        <ProductOriginValue>{vat}%</ProductOriginValue>
      </ProductOriginItem>
      {!!brand?.name && (
        <ProductOriginItem>
          <ProductOriginLabel>
            <FormattedMessage {...utilMessages.brandName} />
          </ProductOriginLabel>
          <Link
            to={generateUrlBrandDetail(brand?.id || '', brand?.name || '')}
            onClick={() => {
              sendGA4Event(EventName.PDP_CLICK_BRAND, {
                product_id: product_id,
                brand_name: brand?.name,
              });
            }}
          >
            <BrandValue>{brand.name}</BrandValue>
          </Link>
        </ProductOriginItem>
      )}
      <ProductOriginItem>
        <ProductOriginLabel>
          <FormattedMessage {...utilMessages.preservation} />
        </ProductOriginLabel>
        <ProductOriginValue>{capitalize(preservationLocal) || 'N/A'}</ProductOriginValue>
      </ProductOriginItem>{' '}
      {isKamereoProduct && (
        <KamereoLogoContainer>
          <SVGIcon src={kamereoLogo} width={64} height={44} />
        </KamereoLogoContainer>
      )}
    </ProductOriginInfo>
  );
};

export default memo(ProductDetailsOriginInfo);
